import { useState, useContext } from "react";
import ApiClient from "../lib/Api";

export default function Form({ onSubmit = () => { } }) {
  const [query, setQuery] = useState('');
  const apiClient = new ApiClient();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setQuery("");
    const response = await apiClient.post('/recommendation', { prompt: query });
    onSubmit(response.reply);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full max-w-2xl bg-white/80 rounded-lg shadow-lg p-6 backdrop-blur"
    >
      <div className="flex space-x-2">
        <label htmlFor="animation-input" className="sr-only">
          Animation prompt
        </label>
        <input
          id="animation-input"
          type="text"
          value={query}
          onChange={(e) => setQuery(e.currentTarget.value)}
          placeholder="What kind of animation do you want?"
          className="flex-1 rounded-lg border-2 border-[#e8a86b] px-4 py-3 text-gray-900 placeholder-gray-500 
                       focus:border-[#d18c48] focus:ring-2 focus:ring-[#d18c48] focus:outline-none
                       focus:border transition-all duration-200 ease-in-out"/>
        <button
          type="submit"
          className="rounded-lg bg-[#6ed9ab] px-6 py-3 font-semibold text-white 
                       hover:bg-[#55c497] active:bg-[#3aa87e] 
                       focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#55c497]
                       transition-colors duration-200 ease-in-out">
          Ask
        </button>
      </div>
    </form>

  );
}
